import Vue from 'vue'
import VueResource from 'vue-resource'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import vuetify from '@/plugins/vuetify'
import Amplify, * as AmplifyModules from 'aws-amplify'
import { AmplifyPlugin } from 'aws-amplify-vue'
import awsExports from '@/aws-exports'
import axiosWithInterceptor from '@/services/interceptor'
import VCurrencyField from 'v-currency-field'
import excel from 'vue-excel-export'

Amplify.configure(awsExports)

Vue.config.productionTip = false
Vue.prototype.$axios = axiosWithInterceptor.instance
Vue.use(AmplifyPlugin, AmplifyModules)
Vue.use(VueResource)
Vue.use(excel)

Vue.use(VCurrencyField, {
  locale: 'pt-BR',
  decimalLength: 2,
  autoDecimalMode: true,
  min: null,
  max: null,
  defaultValue: 0,
  valueAsInteger: false,
  allowNegative: true
})

Vue.filter('toCurrency', (value: any) => {
  if (typeof value !== 'number') return value

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2
  })
  return formatter.format(value)
})

Vue.filter('date', (value: any) => value && value !== undefined ? new Date(value).toLocaleDateString() : '-')
Vue.filter('brl', (value: any) => value ? `R$ ${value.toFixed(2).toString().replace('.', ',')}` : 'R$ 0,00')

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
